<template>
  <span>
    <el-dropdown
      :style="'margin-left:' + margin + 'px;margin-right:' + margin + 'px;'"
    >
      <el-button type="primary" :icon="icon">
        报表打印<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <!-- 修正事件绑定方式，确保事件对象正确传递 -->
        <el-dropdown-item
          v-for="item in ReportTypeList"
          :key="item.DicCode"
          :command="item.DicCode"
          @click.native="handleItemClick(item.DicCode, $event)"
        >
          {{ item.DicName }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="350px">
      <span
        >报表打印程序未启动,如未安装插件请先<a
          target="_blank"
          href="https://chaiche.huayantech.net:8195/files/HYCCPrint.exe"
          >下载</a
        >安装; 若已安装请刷新页面重试!
      </span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="reOpenPrint">重试</el-button> -->
        <el-button type="primary" @click="dialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <!-- 原生文件输入框 (隐藏) -->
    <input
      ref="fileInput"
      type="file"
      :multiple="multiple"
      :accept="accept"
      style="display: none"
      @change="handleFileSelect"
    />
    <el-upload
      ref="upload"
      class="avatar-uploader"
      :show-file-list="false"
      :action="action"
      :headers="headers"
      :multiple="false"
      accept=".fr3"
      :before-upload="beforeUpload"
      :on-success="handlerSuccess"
      :on-error="handlerError"
      :on-remove="handlerRemove"
      :data="fromdata"
      :auto-upload="true"
      style="display: none"
    >
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
  </span>
</template>
<script>
import { MessageBox } from "element-ui";
import { Loading } from "element-ui";
export default {
  props: {
    margin: {
      type: Number,
      default: 10,
    },
    icon: {
      type: String,
      default: "el-icon-printer",
    },
    PrintName: {
      //打印类型 多个逗号隔开
      type: String,
      default: "",
    },
    //报告单模版(默认基础模版)

    // 打印格式 0:预览 1:打印 2:设计
    printformatter: {
      type: String,
      default: "0",
    },
    //查询条件
    options: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      ReportTypeList: [], //报表类型数据源
      isconnsocket: false, //是否连接成功socket
      _socket: {}, //socket连接
      dialogVisible: false,
      loadingInstance: {}, //loading
      setTimeHandler: {}, //延迟SetTime句柄
      printtype: "",
      headers: { Authorization: "Bearer " + this.$g.getToken() },
      fromdata: {},
      reportType: "",
    };
  },
  watch: {},
  mounted() {
    var that = this;
    //先创建websocket
    if (!that.isconnsocket) {
      that.websocketservice();
    }
    var print = that.PrintName;
    setTimeout(() => {
      //未连接成功
      if (!that.isconnsocket) {
        //启动程序
        that.runPrintServer();
      }

      //加载报表类型
      that
        .$get("DataDic/GetItemsByType", { dicType: "ReportType" })
        .then((r) => {
          var rows = r.Result;
          if (print != "") {
            var prints = print.split(",");
            that.ReportTypeList = rows.filter((p) => {
              return prints.indexOf(p.DicCode) > -1;
            });
          } else {
            that.ReportTypeList = r.Result;
          }
        });
      //连接websocket
      setInterval(() => {
        //socket 未连接进行连接
        if (!that.isconnsocket) {
          that.websocketservice();
        }
      }, 10000);
    }, 1300);
  },
  computed: {
    action() {
      this.fromdata = { type: this.reportType };
      return this.$g.host + "/api/Report/UploadReport";
    },
  },
  methods: {
    websocketservice() {
      var that = this;
      try {
        this._socket = new WebSocket("ws://localhost:61360/hyprint");
        //this._socket = new WebSocket("ws:///hyprint");
        this._socket.onmessage = function (evt) {
          if (
            evt != null &&
            evt.data != null &&
            evt.data.indexOf("code") > -1
          ) {
            var res = JSON.parse(evt.data);
            if (res.code != "1") {
              that.$message.error(res.message);
              that.closeloading();
              clearTimeout(that.setTimeHandler); //取消超时提醒
            } else {
              if (res.message == "打印完成") {
                that.closeloading();
                clearTimeout(that.setTimeHandler); //取消超时提醒
              }
            }
          }
        };
        this._socket.onopen = function () {
          that.isconnsocket = true;
        };
        this._socket.onclose = function () {
          that.isconnsocket = false;
        };

        this._socket.onerror = function () {
          that.isconnsocket = false;
        };
      } catch (ex) {
        that.isconnsocket = false;
      }
    },
    loading() {
      this.loadingInstance = Loading.service();
    },
    closeloading() {
      var that = this;
      that.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        that.loadingInstance.close();
      });
    },
    //启动报表服务程序
    runPrintServer() {
      const link = document.createElement("a");
      link.href = "hyccservice://print?url=socketprint";
      link.click();
      link.remove();
    },
    //重新启动插件并打印
    reOpenPrint() {
      this.dialogVisible = false;
      this.runPrintServer();
      var that = this;
      setTimeout(() => {
        that.print(this.printtype);
      }, 300);
    },
    print(type, optoin) {
      var that = this;
      //未启动报表插件给予提醒
      if (!this.isconnsocket) {
        this.dialogVisible = true;
        return;
      }
      var options = {
        type: type, //报告单类型
        mode: this.mode, //报告单模式
        printformatter: this.printformatter, //打印格式 0:预览 1:打印 2:设计
        options: { ...this.options, ...optoin }, //查询条件
      };
      this.$post("Report/GetReportData", options).then((r) => {
        if (r.Code == "1") {
          this.loading();
          var reportdata = r.Result;
          this._socket.send(reportdata);
          //十秒关闭loading
          this.setTimeHandler = setTimeout(() => {
            that.$message.error("连接打印服务响应超时,请重试");
            that.closeloading();
          }, 10000);
        }
      });
      //alert();
      // var options = {
      //   url: window.configs.host + "/api/Report/GetReportData",//api 服务地址,websocket不配置
      //   //api dto
      //   data: {
      //     type: type,//报告单类型
      //     mode: this.mode,//报告单模式
      //     printformatter: this.printformatter,//打印格式 0:预览 1:打印 2:设计
      //     options: this.options
      //   }
      // }
      // const link = document.createElement('a');
      // link.href = 'hyccservice://print/?url=' + JSON.stringify(options);
      // link.click();
      // link.remove();
    },
    handleItemClick(command, event) {
      // 现在可以正确获取事件对象和ctrlKey状态
      console.log("选中的命令:", command);
      console.log("是否按住Ctrl键:", event.ctrlKey);

      this.printtype = command;

      // 处理Ctrl键逻辑
      if (event.ctrlKey) {
        console.log("Ctrl+点击:", command);
        this.printformatter = "2";
        // Ctrl+点击的业务逻辑
      } else if (event.altKey) {
        console.log("Alt+点击:", command);
        this.reportType = command;

        // 触发原生文件选择框
        this.$refs.fileInput.click();
        return;
      } else {
        this.printformatter = "0";
        console.log("普通点击:", command);
        // 普通点击的业务逻辑
      }

      // 原有事件分发逻辑
      const clickEvent = this.$listeners["onClickPrint"];
      if (!clickEvent) {
        this.print(command);
        return;
      }

      this.$emit("onClickPrint", command, (res) => {
        if (res !== false) {
          this.print(command, res);
        }
      });
    },
    // 处理文件选择
    handleFileSelect(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;

      // 将选择的文件传递给el-upload组件
      if (this.$refs.upload) {
        // 手动将文件添加到上传组件
        this.$refs.upload.handleStart(files[0]);
        // 手动触发上传
        this.$refs.upload.submit();
      }

      // 重置input值，确保相同文件也能触发change事件
      event.target.value = "";
    },
    beforeUpload(file) {
      //console.log(file.type);
      // var filetype = new string[] { "image/jpg", "image/jpeg", "image/png" };
      // const isJPG = file.type === "fr3";
      // if (!isJPG) {
      //   this.$message.error("上传文本只能是 fr3格式!");
      //   return false;
      // }
      this.loadingInstance = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    handlerSuccess(res) {
      if (res.Code == "1") {
        this.src = res.Result.url;

        this.$emit("success", res.Result.path); //v-model绑定数据库中要存储的图片路径
      } else {
        this.$emit("success", "");
      }
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
      this.$message.success("上传成功");
    },
    handlerError(error) {
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
      this.$alert("数据请求异常,请联系管理员", "发生错误");
      this.$emit("error");
    },
    handlerRemove() {
      this.$emit("error");
    },
  },
};
</script>

<style></style>
